//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgCheckedCheckbox } from '../icons/CheckedCheckbox';

export function CheckedCheckboxIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCheckedCheckbox} data-qa="CheckedCheckboxIcon">
      <svg />
    </SvgIcon>
  );
}
